import React from 'react';
import { MainNavigationMenu } from './MainNavigationMenu';
import { CrossIcon } from './CrossIcon';
import { ContactButtons } from './ContactButtons';
import { ExchangeRateSection } from './ExchangeRateSection';
import { SearchCruise } from './SearchCruise';
import { LocaleConfigContext } from '../../../../contexts/locale-config/locale-config';
import { ILocaleConfig } from '@interfaces';

const styleMenuFlex: any = {
    display: 'flex',
    flexDirection: 'column',
};
const styleCloseButton: any = {
    alignSelf: 'flex-end',
    padding: '10px',
    marginTop: '-10px',
    cursor: 'pointer',
};

export class NavigationMenuContainer extends React.Component<any> {
    static contextType = LocaleConfigContext;

    declare context: React.ContextType<typeof LocaleConfigContext>;

    public render() {
        const styleMenu: any = {
            width: '100%',
            position: 'fixed',
            top: '0px',
            bottom: '0px',
            left: this.props.isOpen ? '0' : '-100%',
            background: this.props.isOpen ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0)',
            transition: 'background 0.15s ease-in-out',
            zIndex: 999,
        };

        const styleMenuWrapper: any = {
            width: '80%',
            maxWidth: '400px',
            margin: '0px',
            padding: '15px 0px',
            position: 'fixed',
            left: this.props.isOpen ? '0' : '-100%',
            transition: 'left 0.25s ease-in-out',
            top: '0px',
            bottom: '0px',
            background: 'white',
            overflow: 'auto',
        };

        const crossIconContainer: any = {
            marginLeft: 'auto',
        };
        const localeConfig: ILocaleConfig = this.context;
        return (
            <div style={styleMenu} onClick={this.props.closeMenuClick} role="presentation">
                <div
                    style={styleMenuWrapper}
                    onClick={(e) => e.stopPropagation()}
                    role="presentation"
                >
                    <div style={styleMenuFlex}>
                        {/* eslint-disable-next-line */}
                        <span style={crossIconContainer} onClick={this.props.closeMenuClick}>
                            <CrossIcon style={styleCloseButton} width={44} height={44} />
                        </span>

                        <MainNavigationMenu menuItems={this.props.header.mainNavigation} />
                        {this.props.header.exchangeRate && (
                            <ExchangeRateSection {...this.props.header.exchangeRate} />
                        )}
                        <SearchCruise
                            apiHost={`https://backend.dreamlines.com/${
                                localeConfig.code === 'au' ? 'cruiseaway' : localeConfig.code
                            }`}
                            brandConfigSlugs={[
                                {
                                    slugName: 'searchresults',
                                    slugValue: localeConfig.slugs.search,
                                },
                            ]}
                            contentEndpoint={'https://www.dreamlines.de'}
                        />
                        <ContactButtons />
                    </div>
                </div>
            </div>
        );
    }
}
